import { defineMessages } from 'react-intl';
import { protocolsListViewMessages } from './protocols-list-view.messages';

const shortcutMarketplaceModalMessagesBase = defineMessages({
  browseShortcuts: {
    defaultMessage: 'Browse shortcuts',
    id: 'OUH6A6/t2l',
    description:
      'Title and screen-reader description for the shortcut marketplace browse view',
  },
  createShortcut: {
    defaultMessage: 'Create shortcut',
    id: 'sHxncWA96K',
    description: 'Button label and aria-label to open the custom shortcut creation form',
  },
  searchShortcuts: {
    defaultMessage: 'Search shortcuts',
    id: 'ovCIOhEzNW',
    description: 'Placeholder for filtering shortcuts in the marketplace',
  },
  clearShortcutSearch: {
    defaultMessage: 'Clear search',
    id: '4YJHutR26p',
  },
  noShortcutsFound: {
    defaultMessage: 'No shortcuts found',
    id: 'BG+aTDM/Gk',
    description: 'Empty state when search or filters return no shortcuts',
  },
  customProtocol: {
    defaultMessage: 'Custom protocol',
    id: '7QSMV4LUf5',
    description:
      'Default description for a user-created shortcut when the description field is empty',
  },
  backAria: {
    defaultMessage: 'Back',
    id: '5eMntNNu2O',
    description: 'Accessibility label for returning from the marketplace on mobile',
  },
});

/** Merged after `defineMessages` so @formatjs/cli can statically parse literals only. */
export const shortcutMarketplaceModalMessages = {
  ...shortcutMarketplaceModalMessagesBase,
  closeAria: protocolsListViewMessages.closeAria,
  savedShortcutQuota: protocolsListViewMessages.savedShortcutQuota,
  savedShortcutLimitReached: protocolsListViewMessages.savedShortcutLimitReached,
};
